Object.defineProperty(exports,"__esModule",{value:true});exports.creators=exports.default=exports.actions=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _reduxOrm=require('redux-orm');
var _utils=require('./utils');function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var actions=exports.actions={
UPSERT_STORE_RULES:'UPSERT_STORE_RULES'};var





StoreRule=function(_Model){_inherits(StoreRule,_Model);function StoreRule(){_classCallCheck(this,StoreRule);return _possibleConstructorReturn(this,(StoreRule.__proto__||Object.getPrototypeOf(StoreRule)).apply(this,arguments));}_createClass(StoreRule,[{key:'toString',value:function toString()















{
return'Store rule: '+this.id;
}}],[{key:'reducer',value:function reducer(action,StoreRule,session){if(!action)return undefined;switch(action.type){case actions.UPSERT_STORE_RULES:var rules=action.payload.rules;rules.forEach(function(r){StoreRule.upsert(r);});break;}return undefined;}}]);return StoreRule;}(_reduxOrm.Model);exports.default=StoreRule;

StoreRule.modelName='StoreRule';

StoreRule.fields={
id:(0,_reduxOrm.attr)(),
status:(0,_reduxOrm.attr)(),
condition:(0,_reduxOrm.attr)(),
parameter:(0,_reduxOrm.attr)(),
expectation:(0,_reduxOrm.attr)(),
actual:(0,_reduxOrm.attr)(),
action:(0,_reduxOrm.attr)(),
sourceAttribute:(0,_reduxOrm.attr)(),
parameterType:(0,_reduxOrm.attr)(),
createdAt:(0,_reduxOrm.attr)(),
updatedAt:(0,_reduxOrm.attr)(),
lastValue:(0,_reduxOrm.attr)(),
additionalInformation:(0,_reduxOrm.attr)(),
storeId:(0,_reduxOrm.fk)('Store','storeRuleIds')};


var upsertStoreRules=function upsertStoreRules(rules){
var objs=rules?rules.map((0,_utils.filterInput)(StoreRule)):[];

return{
type:actions.UPSERT_STORE_RULES,
payload:{
rules:objs}};


};

var creators=exports.creators={
upsertStoreRules:upsertStoreRules};